import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { Observable } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { CryptoService } from 'src/app/core/services/crypto.service';
import { LocationsService } from 'src/app/core/services/locations/locations.service';
import { ApiService } from 'src/app/services/api';
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-refer-earn', 
  templateUrl: './refer-earn.component.html', 
  styleUrls: ['./refer-earn.component.scss'], 
})
export class ReferEarnComponent {
  @ViewChild("referEmail") referEmail;
  @ViewChild("referSms") referSms;

   breadcrumbItems: breadcrumbItem[] = [
      {
        label: "Home",
        active: false,
        url: "/home",
      },
    
      {
        label: "Referral Program",
        active: true,
        url: "",
      },
    ];
  referralForm: FormGroup;
  token: string | string[];
  GLOBALURL = this.ApiService.getBaseURL();
  currency: any = this.cookieService.get("currency");
  userAppId: any;
  retailView: string;
  businessName: string;
  Apikey: any;
  httpOptions: { headers: HttpHeaders; };
  placeholder: string = "424-403-2867";
  names: string[] = ['Alice', 'Bob', 'Charlie', 'Diana', 'Eve'];
  preferredCountries: CountryISO[];
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  referralCode: any;
  employeeName: any;
  merchantId: any;
  referralLink: string;
  
  constructor(private fb: FormBuilder,
    private modalService: NgbModal,
    private locationService: LocationsService,
    private ApiService: ApiService,
        private BreadcrumbService: BreadcrumbService,
        private cookieService: CookieService,
        private http: HttpClient,
        private toastr: AlertService,
        
        private cryptoService: CryptoService,  @Inject(DOCUMENT) private document: Document,
      private renderer: Renderer2,) {
    this.initializeForm();
  }

  ngOnInit(){
    this.merchantId = this.cookieService.get("merchantId");
    this.BreadcrumbService.setValue(this.breadcrumbItems);
    const userCountry = this.locationService.getUserCountry();
    this.preferredCountries = userCountry === CountryISO.UnitedKingdom
      ? [CountryISO.UnitedKingdom]
      : [userCountry, CountryISO.UnitedKingdom];
      this.getApiKey().subscribe((data) => {
        this.Apikey = data;
      });
      const employeeId = this.cookieService.get("employeeId");
    this.getReferralCode(employeeId);
  }

  apiKey$: Observable<any>

  getApiKey(): Observable<any> {
    if (!this.apiKey$) {
      this.apiKey$ = this.http.get(this.GLOBALURL + "/credentialsv2", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: new HttpParams().set("env", environment.env),
      }).pipe(
        map((response: any) => {
          this.Apikey = response.response.filter((x: any) => x.name === "chatGptKey")[0].value;
          this.Apikey = this.cryptoService.decrypt(this.Apikey)
          console.log("API", this.Apikey)
          // this.googleApiKey = response.response.filter((x: any) => x.name === "googleApiKey")[0].value;
          this.httpOptions = {
            headers: new HttpHeaders({
              Authorization: `Bearer ${this.Apikey}`,
            }),
          };
          return this.Apikey;  // Optionally return the API key
        }),
        catchError(error => error),
   shareReplay(1)  // Ensure the observable is shared and replay the last emitted value
      );
    }
    return this.apiKey$;
  }

  initializeForm(): void {
    this.referralForm = this.fb.group({
      referralMail: this.fb.group({
        mailId: ['', [Validators.required, Validators.email]]
      }),
      referralMobile: this.fb.group({
        Mobile: ['', Validators.required],
      }),
      
    });
  }
  isControlInvalid(controlPath: string): boolean {
    const control = this.referralForm.get(controlPath);
    return control && control.invalid && control.touched;
  }
  getReferralCode(employeeId: string) {
    const payload = { employeeId }; // Prepare your payload
  
    this.http.post(this.GLOBALURL + "/user/reffercode", payload, this.httpOptions)
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.error(response.message);
          } else {
            this.referralCode = response.response.referralCode;
            this.employeeName = response.response.employeeName;
            this.referralLink = response.response.referralLink;
            // this.referralLink = `${environment.frontendBaseUrl}/account/auth/signup?REF_CODE=${this.referralCode}`;
            
            // Handle additional response data if needed
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }
  onSubmit(): void {
    if (this.referralForm.valid) {
      console.log('Form Submitted Successfully!', this.referralForm.value);
    } else {
      console.log('Form is invalid. Please check the fields and try again.');
    }
  }


  activeClass() {
    const body = this.document.body;
    this.GetbodyClass(body);
  }

  GetbodyClass(bodyclass: any) {
    const body = this.renderer.selectRootElement("body", true);
    const bodyClasses = body.classList;
    const bodyClassesArray = Array.from(bodyClasses);
    if (bodyClassesArray[0] === "sidebar-enable") {
      bodyclass.classList.add("vertical-collpsed");
    }
  }
  sendMailPopup() {
    this.modalService.open(
      this.referEmail,
      { centered: true, size: "lg" }
    )
  }
  sendSmsPopup() {
    this.modalService.open(
      this.referSms,
      { centered: true, size: "lg" }
    )
  }
  sendMail() {
    console.log("Mail Sent")
    var params = {
      "email": this.referralForm.value.referralMail.mailId,
      "referralCode":this.referralCode,
      "merchantId":this.merchantId
     }
    this.http
      .post(this.GLOBALURL + "/merchant/referralCode/invitation", params, this.httpOptions)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
          } else {
          this.toastr.success(response.message);
          this.referralForm.get('referralMail').reset(); 
          this.modalService.dismissAll();

          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          // this.alertService.error(message);
          this.toastr.error(message);
        }
      );
  
  }
  clearMailForm(){
    this.referralForm.get('referralMail').reset();
  }
  sendSms() {
    console.log("SMS Sent")
    var params = {
      "phoneNumber": this.referralForm.value.referralMobile.Mobile.e164Number,
      "referralCode":this.referralCode,
      "merchantId":this.merchantId
     }
    this.http
      .post(this.GLOBALURL + "/merchant/referralCode/invitation", params, this.httpOptions)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
            
          } else {
          this.toastr.success(response.message);
          this.modalService.dismissAll();
          this.referralForm.get('referralMobile').reset(); // Reset the form

          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          // this.alertService.error(message);
          this.toastr.error(message);
        }
      );
  }
  clearSmsForm(){
    this.referralForm.get('referralMobile').reset();
  }
  copyLink() {
    if (navigator.clipboard) {
      // Use the Clipboard API directly
      navigator.clipboard.writeText(this.referralLink).then(() => {
        this.toastr.success('Referral link copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy the link: ', err);
        this.toastr.error('Could not copy the link, please try again.');
      });
    } else {
      // Fallback for older browsers
      this.copyToClipboardFallback(this.referralLink);
    }
  }

  // Fallback method for browsers that do not support the Clipboard API
  copyToClipboardFallback(link: string) {
    const textArea = document.createElement('textarea');
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      this.toastr.success('Referral link copied to clipboard!');
    } catch (err) {
      this.toastr.error('Could not copy the link, please try again.');
      console.error('Failed to copy the link: ', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
  // sendMail() {
  //   console.log("Mail Sent")
  //   var params = {
  //     "mailId": this.referralForm.value.referralMail.mailId,
  //     "referralCode":this.referralCode,
  //    }
  //   this.http
  //     .post(this.GLOBALURL + "/merchant/sendReffralMail", params, this.httpOptions)
  //     .subscribe(
  //       (response: any) => {
  //         if (response.success == 0) {
  //           this.toastr.error(response.message);
  //         } else {
  //         this.toastr.success(response.message);
  //         this.modalService.dismissAll();

  //         }
  //       },
  //       (error) => {
  //         const message = this.ApiService.errorMessage(error)
  //         // this.alertService.error(message);
  //         this.toastr.error(message);
  //       }
  //     );
  
  // }
  // sendSms() {
  //   console.log("SMS Sent")
  //   var params = {
  //     "mobile": this.referralForm.value.referralMobile.Mobile.e164Number,
  //     "referralCode":this.referralCode,
  //    }
  //   this.http
  //     .post(this.GLOBALURL + "/merchant/sendReffralSms", params, this.httpOptions)
  //     .subscribe(
  //       (response: any) => {
  //         if (response.success == 0) {
  //           this.toastr.error(response.message);
            
  //         } else {
  //         this.toastr.success(response.message);
  //         this.modalService.dismissAll();

  //         }
  //       },
  //       (error) => {
  //         const message = this.ApiService.errorMessage(error)
  //         // this.alertService.error(message);
  //         this.toastr.error(message);
  //       }
  //     );
  // }
}